
import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AppService } from "../../shared/services/app.service";
import { ChartDoughnutComponent } from "./components/chart-doughnut/chart-doughnut.component";
import { ChartComponent } from "./components/chart/chart.component";
import { DashboardBanneromponent } from "./components/dashboard-banner/dashboard-banner.component";
import { DashboardLinkomponent } from "./components/dashboard-link/dashboard-link.component";
import { QuicksightComponent } from "./components/quicksight/quicksight.component";
import { DashboardService } from "./services/dashboard.service";
import { SafeResourceHtml } from "./services/safeResourceHtml.pipe";
import { TranslateModule } from "../../pipes/translate.module";
import { TableauComponent } from "./components/tableau/tableau.component";
import { AvighnaAiComponent } from "./components/avighna-ai/avighnaai.component";
import { SupersetComponent } from "./components/superset/superset.component";
import { NgMultiSelectDropDownModule } from "../search-select/ng-multiselect-dropdown.module";
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { HraComponent } from "./components/hra/hra.component";
import { DashboardCtaComponent } from "./components/dashboard-cta/dashboard-cta.component";
import { GoalsTrackerComponent } from "./components/goals-tracker/goals-tracker.component";
import { TrackHealthVitalsComponent } from "./components/track-health-vitals/track-health-vitals.component";
import { PowerBIComponent } from "./components/powerbi/powerbi.component";
import { DashboardFiltersComponent } from "./components/dashboard-filters/dashboard-filters.component";

@NgModule({
    declarations: [
        DashboardLinkomponent,
        DashboardBanneromponent,
        QuicksightComponent,
        TableauComponent,
        AvighnaAiComponent,
        SafeResourceHtml,
        HraComponent,
        DashboardCtaComponent,
        GoalsTrackerComponent,
        TrackHealthVitalsComponent,
        SupersetComponent,
        PowerBIComponent,
        DashboardFiltersComponent
    ],
    providers:[
        DashboardService
    ],
    imports:[
        FormsModule,
        CommonModule,
        TranslateModule,
        NgMultiSelectDropDownModule,
        CarouselModule.forRoot()
    ],
    exports:[
        DashboardLinkomponent,
        DashboardBanneromponent,
        QuicksightComponent,
        SupersetComponent,
        TableauComponent,
        AvighnaAiComponent,
        HraComponent,
        DashboardCtaComponent,
        GoalsTrackerComponent,
        TrackHealthVitalsComponent,
        SafeResourceHtml,
        PowerBIComponent,
        DashboardFiltersComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DashboardModule {
    public entryComponents: any = [
        DashboardLinkomponent,
        DashboardBanneromponent,
        QuicksightComponent,
        SupersetComponent,
        TableauComponent,
        HraComponent,
        DashboardCtaComponent,
        GoalsTrackerComponent,
        TrackHealthVitalsComponent,
        AvighnaAiComponent,
        PowerBIComponent,
        DashboardFiltersComponent
    ]
    public appService: AppService;
  constructor(public injector: Injector) {
    this.appService = injector.get(AppService);
    this.appService._factories["modules"]["DashboardModule"] = this.entryComponents;
    if (this.entryComponents && this.entryComponents.length) {
      this.appService.buildFactory(this.entryComponents);
    }
  }
}